import { ComponentChild, FunctionComponent, h } from 'preact';
import { OverlayView } from '@react-google-maps/api';

export type MarkerData = {
	position: google.maps.LatLngLiteral;
	icon: ComponentChild;
};

const getPixelPositionOffset = (width: number, height: number) => ({
	x: -(width / 2),
	y: -height
});

const MapMarker: FunctionComponent<MarkerData> = ({ position, icon }) => {
	return (
		<OverlayView
			mapPaneName={OverlayView.MARKER_LAYER}
			getPixelPositionOffset={getPixelPositionOffset}
			position={position}
		>
			<div className="marker-container">{icon}</div>
		</OverlayView>
	);
};

export default MapMarker;
